import { some } from 'lodash'

export default function anyAdultMembersWithoutIncome(members) {
  return some(members, (member) => member.noIncome && member.isAdult)
}
